import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import ImmutablePropTypes from 'react-immutable-proptypes'
import classnames from 'classnames'
import { canUseDOM } from '../../lib/utils'
import useWindowScroll from '../../hooks/useWindowScroll'
import { TICKER_COOKIE_PREFIX, closeTicker } from './tickerActions'
import { useCookies } from 'react-cookie'
import { config } from '../../../config/config'
import './ticker.pcss'


/**
 * Ticker component used on top of items list and on the bottom of page
 */
const Ticker = ({ dispatch, ticker }) => {
  const [cookies, setCookie, removeCookie] = useCookies() // eslint-disable-line no-unused-vars

  const { scrollY, direction } = useWindowScroll()
  const isDuckDuckGo = canUseDOM && window.navigator.userAgent.includes('DuckDuckGo')
  const changePosition = isDuckDuckGo || direction === 'up' || scrollY < 12

  const handleClose = () => {
    const { id, replayHours } = ticker.toJS()
    setCookie(TICKER_COOKIE_PREFIX + id, 'true', {...config.cookieOptions, maxAge: replayHours * 3600})
    dispatch(closeTicker(id))
  }

  const { position, text, image, link, bgColor, fgColor } = ticker.toJS()

  // Text and image contained in Anchor or Div, depending on whether there is a link
  const ContentTag = link ? 'a' : 'div'
  const linkProps = link ? { href: link, target: '_blank', rel: 'noopener' } : {}
  if (link && (link.startsWith('/') || link.startsWith('https://www.ampparit.com'))) {
    linkProps.target = '_top'
  }

  return (
    <div
      className={ classnames('ticker', `ticker--${position}`, `gtm-${position}-ticker`, { 'mobile-nav-position': position === 'bottom' && changePosition }) }
      style={ { backgroundColor: bgColor, color: fgColor } }
    >
      <ContentTag className='ticker__content-wrapper' { ...linkProps }>
        { !!image && <img className='ticker__image' src={ image } alt='' /> }
        <span
          className='ticker__text'
          dangerouslySetInnerHTML={ { __html: text } }
        />
      </ContentTag>
      <button type='button' className='ticker__close-button' onClick={ handleClose } aria-label='Sulje'>
        <span className='fa fa-times' aria-hidden='true' />
      </button>
    </div>
  )
}

Ticker.propTypes = exact({
  dispatch: PropTypes.func.isRequired,
  ticker: ImmutablePropTypes.map.isRequired,
})

export { Ticker }
